export default {
  "HitPaw Online Audio Joiner": "HitPaw Çevrimiçi Ses Birleştirici",
  "Merge Audio": "Sesi Birleştir",
  "Merge multiple audio tracks into one.": "Birden fazla ses parçasını tek bir parçada birleştirin.",
  "Merge New": "Yeni Birleştir",
  "Merge failed": "Birleştirme başarısız",
  "Fade in": "Açılma",
  "Fade out": "Karartma",
  "Add tracks": "Parça ekle",
  "Format": "Biçim",
};
